var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-page",
    {
      attrs: {
        "zoom-level": _vm.zoomLevel,
        "page-settings": _vm.layout.PageSettings,
        "show-grid": _vm.showGrid,
        "grid-settings": _vm.layout.EditorSettings.GridSettings,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "header",
          style: { height: _vm.layout.PageSettings.HeadingHeight + "mm" },
        },
        [
          _vm._l(_vm.headerLogos, function (logo, i) {
            return _c("app-logo", { key: i, attrs: { logo: logo } })
          }),
          _vm._l(_vm.headerFreeBlocks, function (block, i) {
            return _c("app-free-block", {
              key: i,
              attrs: { "free-block": block, lang: _vm.lang },
            })
          }),
          _c("app-heading", {
            attrs: {
              heading: _vm.layout.Heading,
              "page-settings": _vm.layout.PageSettings,
              "heading-height": _vm.layout.PageSettings.HeadingHeight,
              lang: _vm.lang,
            },
          }),
          _c("app-client-heading", {
            attrs: {
              heading: _vm.layout.ClientHeading,
              "page-settings": _vm.layout.PageSettings,
              "heading-height": _vm.layout.PageSettings.HeadingHeight,
              lang: _vm.lang,
            },
          }),
          _c("app-section-splitter", {
            model: {
              value: _vm.layout.PageSettings.HeadingHeight,
              callback: function ($$v) {
                _vm.$set(_vm.layout.PageSettings, "HeadingHeight", $$v)
              },
              expression: "layout.PageSettings.HeadingHeight",
            },
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "body" },
        [
          _vm._l(_vm.bodyLogos, function (logo, i) {
            return _c("app-logo", {
              key: i,
              style: { zIndex: 0 },
              attrs: { logo: logo },
            })
          }),
          _vm._l(_vm.bodyFreeBlocks, function (block, i) {
            return _c("app-free-block", {
              key: i,
              attrs: { "free-block": block, lang: _vm.lang },
            })
          }),
          _c(
            "div",
            { staticClass: "inner-body" },
            [
              _c("app-text", {
                attrs: {
                  lang: _vm.lang,
                  title: _vm.layout.TitleStyle,
                  text: _vm.layout.TextStyle,
                  date: _vm.layout.DateStyle,
                  signature: _vm.layout.SignatureStyle,
                },
              }),
              _c("app-table", { attrs: { lang: _vm.lang } }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "footer",
          style: { height: _vm.layout.PageSettings.FooterHeight + "mm" },
        },
        [
          _vm._l(_vm.footerLogos, function (logo, i) {
            return _c("app-logo", { key: i, attrs: { logo: logo } })
          }),
          _vm._l(_vm.footerFreeBlocks, function (block, i) {
            return _c("app-free-block", {
              key: i,
              attrs: { "free-block": block, lang: _vm.lang },
            })
          }),
          _c("app-section-splitter", {
            attrs: { "use-bottom": "" },
            model: {
              value: _vm.layout.PageSettings.FooterHeight,
              callback: function ($$v) {
                _vm.$set(_vm.layout.PageSettings, "FooterHeight", $$v)
              },
              expression: "layout.PageSettings.FooterHeight",
            },
          }),
          _c(
            "div",
            { staticClass: "inner-footer" },
            [
              _c("app-free-lines", {
                attrs: { lang: _vm.lang, lines: _vm.layout.FreeLines },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }